module.exports = __webpack_public_path__ + "img/logo1.c3b81102.png";